import ReviewContractTerms from './ReviewContractTerms';

export default ReviewContractTerms;
